import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MainSidebar = () => {
  const navigate = useNavigate();

  const onClickHandler = (navigationKey: string): void => {
    switch (navigationKey.toLowerCase()) {
      case 'products':
        navigate('/tenantList/');
        break;
      case 'home':
        navigate('/tenantList/');
        break;
      case 'dashboard':
        navigate('/tenantList/');
        break;
      default:
        navigate('/tenantList/');
    }
  };

  return (
    <aside className="fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform -translate-x-full bg-dark-blue border-r border-white sm:translate-x-0" aria-label="Sidebar">
      <div className="h-full px-3 pb-4 overflow-y-auto bg-dark-blue">
        <div className="mt-10 space-y-2">
          <h2 className="uppercase text-white font-extrabold text-3xl">John Doe</h2>
          <h2 className="uppercase text-white font-bold text-xl">d. in medicine</h2>
        </div>
        <div className="mt-10 space-y-4">
          <form>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <button type="submit">
                  <svg aria-hidden="true" className="w-6 h-6 text-light-blue stroke-light-blue" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </button>
              </div>
              <input type="search" id="default-search" className="block w-full p-4 pl-10 text-light-blue text-xl font-semibold uppercase border  border-dark-blue rounded-lg bg-gray-50 focus:ring-blue focus:border-blue" placeholder="Search..." required />
            </div>
          </form>
          <button title="products" className="w-full flex items-center p-4 border border-dark-blue rounded-lg bg-white cursor-pointer hover:bg-light-blue hover:text-white hover:stroke-white hover:border hover:border-white" onClick={() => onClickHandler('products')}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} className="w-6 h-6 stroke-dark-blue">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
            </svg>
            <h3 className="pl-3 uppercase text-xl font-semibold">products</h3>
          </button>
          <button title="products" className="w-full flex items-center p-4 border border-dark-blue rounded-lg bg-white cursor-pointer hover:bg-light-blue hover:text-white hover:stroke-white hover:border hover:border-white" onClick={() => onClickHandler('home')}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} className="w-6 h-6 stroke-dark-blue">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
            <h3 className="pl-3 uppercase text-xl font-semibold">home</h3>
          </button>
          <button title="products" className="w-full flex items-center p-4 border border-dark-blue rounded-lg bg-white cursor-pointer hover:bg-light-blue hover:text-white hover:stroke-white hover:border hover:border-white" onClick={() => onClickHandler('dashboard')}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} className="w-6 h-6 stroke-dark-blue">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
            </svg>
            <h3 className="pl-3 uppercase text-xl font-semibold">dashboard</h3>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default MainSidebar;
